import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const getVehicleLabel = (vehicle) => {
  const registrationNumber = vehicle?.registrationNumber || "Unknown";
  const make = vehicle?.make || "Vehicle";
  return `${registrationNumber} (${make})`;
};

const VehicleBookingCountsChart = ({ data }) => {
  const vehicles = Array.isArray(data?.vehicles) ? data.vehicles : [];

  const categories = useMemo(
    () => vehicles.map((vehicle) => getVehicleLabel(vehicle)),
    [vehicles]
  );

  const series = useMemo(
    () => [
      {
        name: "Booking Count",
        data: vehicles.map((vehicle) => Number(vehicle?.bookingCount) || 0),
      },
    ],
    [vehicles]
  );

  const options = useMemo(
    () => ({
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#2F80ED"],
      xaxis: {
        categories,
        labels: {
          rotate: -35,
          trim: true,
        },
        title: {
          text: "Vehicle",
        },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        title: {
          text: "No. of Bookings",
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      tooltip: {
        y: {
          formatter: (val) => `${val} bookings`,
        },
      },
      noData: {
        text: "No vehicle booking count data available",
      },
    }),
    [categories]
  );

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title mb-0">Vehicle Booking Count</h4>
      </div>
      <div className="card-body">
        <div className="line-chart-style bar-chart">
          <ReactApexChart options={options} series={series} type="bar" height={380} />
        </div>
      </div>
    </div>
  );
};

export default VehicleBookingCountsChart;
